<template>
  <el-dialog
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    :title="title"
    :visible.sync="dialogVisible"
    width="600px"
    center>
    <el-image v-if="formImg" :src="imgIp + formImg" class="form-image"></el-image>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false">关 闭</el-button>
      <!-- <el-button type="primary" size="small" v-print="'signForm'">打 印</el-button> -->
      <!-- <el-button v-if="type === 'written' || type === 'interview'" type="primary" size="small" @click="exportPdf">下 载</el-button> -->
      <el-button v-if="type === 'written' || type === 'interview'" type="primary" size="small" @click="downloadImg">下 载</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getSignImg, getWrittnImg, getInterviewImg } from '@/api/exam'
import { getPdf } from '@/utils/exportPdf'
import config from '@/utils/index'

export default {
  name: 'SignForm',
  data() {
    return {
      loading: false,
      dialogVisible: false,
      imgIp: config.imgIp,
      formImg: '',
      title: '',
      examineeId: null,
      type: ''
    }
  },
  methods: {
    init(type, id) {
      this.formImg = ''
      this.examineeId = id
      this.dialogVisible = true
      this.type = type
      if (type === 'sign') {
        this.title = '报名登记表'
        this.getSignImg()
      } else if (type === 'written') {
        this.title = '笔试准考证'
        this.getWrittenImg()
      } else if (type === 'interview') {
        this.title = '面试通知单'
        this.getWrittenImg()
      }
    },
    exportPdf() {
      if (this.type === 'written') {
        getPdf(this.title, 'signForm')
      } else if (this.type === 'interview') {
        getPdf(this.title, 'signForm')
      }
    },
    getSignImg() {
      this.loading = true
      getSignImg(this.examineeId)
        .then(res => {
          this.loading = false
          if (res.code === 200) {
            this.formImg = res.data.imageUrl
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    getWrittenImg() {
      this.loading = true
      getWrittnImg(this.examineeId)
        .then(res => {
          this.loading = false
          if (res.code === 200) {
            this.formImg = res.data.imageUrl
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    getInterviewImg() {
      this.loading = true
      getInterviewImg(this.examineeId)
        .then(res => {
          this.loading = false
          if (res.code === 200) {
            this.formImg = res.data.imageUrl
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    downloadImg() {
      const elt = document.createElement('a');
      elt.setAttribute('href', this.imgIp + this.formImg);
      elt.setAttribute('download', 'file.png');
      elt.style.display = 'none';
      document.body.appendChild(elt);
      elt.click();
      document.body.removeChild(elt);
    }
  }
}
</script>
<style scoped>
#signForm {
  padding: 20px;
}
.form-image {
  width: 100%;
}
</style>
